// extracted by mini-css-extract-plugin
export default {"priority":"apE_LD2nzBf1gyXlTBqk"};